module.exports = __webpack_public_path__ + "img/gptw.a17dfb2f.png";